import { defineMessages } from 'dibs-react-intl';

export const searchBarMessages = defineMessages({
    companyName: {
        id: 'dbl.Header.SearchBar.companyName',
        defaultMessage: '1stDibs',
    },
    search: {
        id: 'dbl.Header.SearchBar.search',
        defaultMessage: 'Search',
    },
    searchPlaceholder: {
        id: 'dbl.Header.SearchBar.placeholder',
        defaultMessage: 'Search 1stDibs',
    },
    closeSearchLabel: {
        id: 'dbl.Header.SearchBar.closeSearchLabel',
        defaultMessage: 'Exit search',
    },
});
